// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2cd5F","right":"styles_right__2cu0S"};